import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class TelemetryEventService {
	private lastEventsToTrack = {};

	/**
	 * Return the description of the last event happened.
	 * @param event: string
	 */
	getDescription(event: string): string {
		if (this.lastEventsToTrack[event] && this.lastEventsToTrack[event] !== null) {
			const description = this.lastEventsToTrack[event];
			this.lastEventsToTrack[event] = '';
			return description;
		}
		return '';
	}

	/**
	 * Set last event with the description
	 * @param event: string
	 * @param description: string
	 */
	setEvent(event: string, description: string): void {
		this.lastEventsToTrack[event] = description;
	}
}
